import { DownloadIcon } from "@chakra-ui/icons";
import ExportDCMatrixButton from "components/Products/ExportDCMatrixButton";
import ExportPricingAndSpecsButton from "components/Products/ExportPricingAndSpecsButton";
import type { ProductFilterQueryVariables } from "components/Products/utils";
import DropDownMenu from "components/Shared/DropDownMenu";
import { EXPORT_BUTTON_PROPS } from "components/Shared/ExportButton";
import ExportProductInformationButton from "./ExportProductInformation";

type Props = ProductFilterQueryVariables & {
  isDisabled?: boolean;
};

export default function DropDownExportMenu({
  isDisabled,
  productLineFilter,
  skuFilter,
}: Props) {
  return (
    <DropDownMenu
      LeftIconComponent={DownloadIcon}
      buttonLabel="Export"
      buttonProps={{
        ...EXPORT_BUTTON_PROPS,
        variant: "outline",
        disabled: isDisabled || undefined,
      }}
      isMenuInPortal
    >
      <ExportPricingAndSpecsButton {...{ productLineFilter, skuFilter }} />
      <ExportDCMatrixButton {...{ productLineFilter, skuFilter }} />
      <ExportProductInformationButton {...{ productLineFilter, skuFilter }} />
    </DropDownMenu>
  );
}
